import React, { useState } from 'react';
import { Minus, Plus } from 'lucide-react';
type FaqItem = {
  question: string;
  answer: string;
};
const FAQS: FaqItem[] = [{
  question: '¿Qué es exactamente Sin Azúcar Club?',
  answer: 'Es una app para simplificar tus comidas sin azúcar. Reúne recetas, menú semanal, lista de compras automática, matching con tu despensa y seguimiento de progreso.'
}, {
  question: '¿Cómo recibo el acceso?',
  answer: 'Apenas confirmado el pago recibís un email con el link de acceso y la contraseña. El acceso es inmediato.'
}, {
  question: '¿Funciona en el celular?',
  answer: 'Sí. Podés usar Sin Azúcar Club desde el celular, la tablet o la computadora. Solo necesitás conexión a internet y un navegador.'
}, {
  question: '¿Las recetas son todas sin azúcar?',
  answer: 'Sí. La app reúne recetas sin azúcar para distintos momentos del día y te permite filtrarlas para elegir más rápido según lo que necesitás cocinar.'
}, {
  question: '¿El acceso tiene suscripción?',
  answer: 'No. Hacés un único pago de $16.990 y accedés de por vida a la app desde cualquier dispositivo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="scroll-mt-8 bg-white px-6 py-16 lg:px-12 lg:py-20" data-id="element-112" data-mp="1arwv93lpo45v">
      <div className="mx-auto max-w-3xl" data-id="element-113" data-mp="1fqqd18816hbu">
        <p className="mb-3 text-center text-sm font-extrabold tracking-[0.16em] text-[#6E8A42]" data-id="element-114" data-mp="11wp9m164w655">TENÉ TODO CLARO</p>
        <h2 className="mb-10 text-center text-3xl font-extrabold tracking-tight text-[#183717] md:text-5xl" data-id="element-115" data-mp="16p0ku06bred0">PREGUNTAS FRECUENTES</h2>

        <div className="space-y-3" data-id="element-116" data-mp="s0vxuk08ogof">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className={`overflow-hidden rounded-2xl border transition-colors duration-300 ${isOpen ? 'border-[#B9CD8A] bg-[#EEF2DF]' : 'border-[#31502A]/10 bg-[#FBF8F1]'}`} data-id="element-117" data-mp="ixuwsxq8dfrm" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#6E8A42]" data-id="element-118" data-mp="2pn55d5e9qwdv">
                  <span className="text-lg font-extrabold text-[#183717]" data-id="element-119" data-mp="38l93l4smbb0w">{faq.question}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? 'bg-[#6E8A42] text-white' : 'bg-white text-[#36572A]'}`} data-id="element-120" data-mp="33mo3r6ha2tcz">
                    {isOpen ? <Minus className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-121" data-mp="2ulq6r859bm3w" /> : <Plus className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-122" data-mp="2ulgjhsbljt1w" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-123" data-mp="1j6kw9hyvwj9q">
                  <div className="overflow-hidden" data-id="element-124" data-mp="3uvhk04mb9q7f">
                    <p className="px-6 pb-5 font-medium leading-relaxed text-[#183717]/70" data-id="element-125" data-mp="2puflmsdyjrf">{faq.answer}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}